import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_qw4qu9fve6: FaireBrandEntity = {
  token: "b_qw4qu9fve6",
  type: "brand",
  name: "Lily Posh",
  avatarUrl:
    "https://cdn.faire.com/fastly/600cf01208f18cad6cf69954d4cecc094c5b2b82f26c207b128706ae4abf7fed.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/96a501069d757ebc512d09663ddd19c2c58f45eacfe06904d626e6595ed7c4e4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/600cf01208f18cad6cf69954d4cecc094c5b2b82f26c207b128706ae4abf7fed.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/96a501069d757ebc512d09663ddd19c2c58f45eacfe06904d626e6595ed7c4e4.png",
  location: "92536, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 24,
  isTopShop: true,
  isInsider: true,
  description: "Hand made beaded bags and accessories.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:55:12.199Z",
    importedBy: "entity-db-cli",
  },
};
